import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-631749d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "has-background-modest level-center is-mobile" }
const _hoisted_2 = ["src", "onerror", "id", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlaceholderImage = _resolveComponent("PlaceholderImage")!

  return (_openBlock(), _createElementBlock("figure", _hoisted_1, [
    (_ctx.thumbnailPath && _ctx.hasThumbnail)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.thumbnailPath,
          onerror: _ctx.notThumbnail,
          id: 'the-item-list-thumbnail-'+_ctx.itemIndex,
          alt: _ctx.$t('rightPane.thumbnailAlt')
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createVNode(_component_PlaceholderImage, {
      type: _ctx.type,
      id: 'the-item-list-icon-'+_ctx.itemIndex
    }, null, 8, ["type", "id"])
  ]))
}